/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import format from 'date-fns/format';
import subDays from 'date-fns/sub_days';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import RichLabel from 'loracoms/RichLabel';
import DatePicker from 'loracoms/DatePicker';
import PageSizer from 'loracoms/PageSizer';
import PanelToolbar from 'loracoms/PanelToolbar';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import IntlMsg from 'lorautils/intl/IntlMsg';
import deviceActions from 'loraactions/device';
import styles from './styles.scss';


function defaultFrom() {
  return startOfDay(subDays(new Date(), 1));
}

function defaultTo() {
  return endOfDay(new Date());
}

const kCommandLabelEnum = [{
  content: 'RXParamSetupReq',
  theme: 'blue',
}, {
  content: 'RXParamSetupAns',
  theme: 'blue',
}, {
  content: 'DutyCycleReq',
  theme: 'red',
}, {
  content: 'DutyCycleAns',
  theme: 'red',
}, {
  content: 'DevStatusReq',
  theme: 'yellow',
}, {
  content: 'DevStatusAns',
  theme: 'yellow',
}, {
  content: 'LinkADRReq',
  theme: 'green',
}, {
  content: 'LinkADRAns',
  theme: 'green',
}, {
  content: 'RXTimingSetupReq',
  theme: 'blue',
}, {
  content: 'RXTimingSetupAns',
  theme: 'blue',
}, {
  content: 'NewChannelReq',
  theme: 'red',
}, {
  content: 'NewChannelAns',
  theme: 'red',
}];

const kFixedKeys = [
  '$time',
  'appeui',
  'args',
  'deveui',
  'name',
  'org',
];


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
  macLog: React.PropTypes.object.isRequired,
};

class MacLog extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      macLog: props.macLog,
      pageSize: 10,
    };
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview.maclog');
  }

  componentWillMount() {
    const { deviceId, getMacLog } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
      pageSize,
    } = this.state;

    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { macLog } = nextProps;
    if (macLog !== this.props.macLog) {
      this.setState({ macLog });
      if (macLog.status === 'success') {
        this.setState({
          list: macLog.data.list,
        });
      }
    }
  }

  handleChangePageSize(pageSize) {
    this.setState({ pageSize });

    const { getMacLog, deviceId } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;
    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize,
    });
  }

  handleChangeFrom(from) {
    const to = endOfDay(from);
    this.setState({ from: startOfDay(from), to });
    const { getMacLog, deviceId } = this.props;
    const { pageSize } = this.state;
    getMacLog(deviceId, {
      after: startOfDay(from).valueOf(),
      before: to.valueOf(),
      limit: pageSize,
    });
  }

  handleChangeTo(to) {
    this.setState({ to: endOfDay(to) });
    const { getMacLog, deviceId } = this.props;
    const { pageSize, from = defaultFrom() } = this.state;
    getMacLog(deviceId, {
      after: from.valueOf(),
      before: endOfDay(to).valueOf(),
      limit: pageSize,
    });
  }

  handleReload() {
    const { getMacLog, deviceId } = this.props;
    const {
      from = defaultFrom(),
      to = defaultTo(),
      pageSize,
    } = this.state;
    getMacLog(deviceId, {
      after: from.valueOf(),
      before: to.valueOf(),
      limit: pageSize,
    });
  }

  render() {
    const {
      pageSize,
      macLog,
      expanded = true,
      from = defaultFrom(),
      to = defaultTo(),
    } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg('maclog')}
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={macLog.status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    const fromPicker = (
      <DatePicker
        date={from}
        onSelect={this.handleChangeFrom}
      />
    );
    const toPicker = (
      <DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => MacLog.handleDisableDate(d, from)}
      />
    );

    const { list = [] } = this.state;
    const extraKeys = _.uniq(
      _.flatMap(
        list,
        r => _.without(_.keys(r), ...kFixedKeys)));

    const rows = list.map((r, idx) => (
      <tr key={`${r.$time}-${r.name}-${idx}`}>
        <td>{format(r.$time, 'YYYY-MM-DD HH:mm:ss')}</td>
        <td><RichLabel content={r.name} enums={kCommandLabelEnum} /></td>
        <td>
          <ul className={styles.parameter}>
            <li>
              <span className={styles.raw}>
                {_.toUpper(r.args)}
              </span>
            </li>
            {extraKeys.map((k) => {
              if (_.has(r, k)) {
                return (
                  <li key={k}>
                    <span className={styles.parsed}>
                      <span className={styles.key}>{k}</span>
                      <span className={styles.value}>{String(r[k])}</span>
                    </span>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </td>
      </tr>
    ));

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
      >
        <PanelToolbar tools={[fromPicker, toPicker]} />
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('time')}</th>
              <th>{this.intlMsg.msg('maccommand')}</th>
              <th>{this.intlMsg.msg('parameter')}</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
        <div className="pull-right">
          <PageSizer
            pageSize={pageSize}
            onChange={this.handleChangePageSize}
            options={[10, 20, 50, 100, 500]}
          />
        </div>
      </Panel>
    );
  }
}


MacLog.propTypes = propTypes;

const mapStateToProps = state => ({
  macLog: state.device.getMacLog,
});

const mapDispatchToProps = {
  getMacLog: deviceActions.getMacLog,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MacLog));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/MacLog/index.jsx